// frontend/packages/business-console/src/services/siteAlertsService.js
//
// Client for the emergency alert banner (emergency_alerts tenant feature).
// Backend is /api/v2/site-alerts (backend/routes/siteAlertsRoutes.js). The
// tenant is attached by the api client's x-business-id interceptor.

import { api } from '@upryzze/services';

// Is the feature on for this business? { enabled: false } on any error so the
// page renders its friendly "not turned on" state.
export async function getSiteAlertsStatus() {
  try {
    const { data } = await api.get('/v2/site-alerts/status');
    return data || { enabled: false };
  } catch {
    return { enabled: false };
  }
}

export async function listSiteAlerts() {
  const { data } = await api.get('/v2/site-alerts');
  return Array.isArray(data?.alerts) ? data.alerts : [];
}

export async function createSiteAlert(input) {
  const { data } = await api.post('/v2/site-alerts', input);
  return data;
}

export async function updateSiteAlert(id, patch) {
  const { data } = await api.patch(`/v2/site-alerts/${id}`, patch);
  return data;
}

export async function endSiteAlert(id) {
  const { data } = await api.post(`/v2/site-alerts/${id}/end`);
  return data;
}

export async function reactivateSiteAlert(id) {
  const { data } = await api.post(`/v2/site-alerts/${id}/reactivate`);
  return data;
}

export async function deleteSiteAlert(id) {
  await api.delete(`/v2/site-alerts/${id}`);
}
